const getIdentityRecord = (user: unknown): Record<string, unknown> => {
  const raw = (user ?? {}) as Record<string, unknown>;
  const nested = raw.data;
  if (nested && typeof nested === "object" && !Array.isArray(nested)) {
    return nested as Record<string, unknown>;
  }
  return raw;
};

export const getRolesFromIdentity = (user: unknown): unknown[] => {
  const identity = getIdentityRecord(user);
  const roles = identity.roles;
  return Array.isArray(roles) ? roles : [];
};

export const getEmployeeIdFromIdentity = (user: unknown): string | null => {
  const identity = getIdentityRecord(user);
  const rawAttributes = identity.attributes;

  let attributes: Record<string, unknown> = {};

  if (rawAttributes && typeof rawAttributes === "object" && !Array.isArray(rawAttributes)) {
    attributes = rawAttributes as Record<string, unknown>;
  } else if (typeof rawAttributes === "string") {
    try {
      const parsed = JSON.parse(rawAttributes);
      if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
        attributes = parsed as Record<string, unknown>;
      }
    } catch {
      attributes = {};
    }
  }

  // New way: ref_attributes mapping puts employee_profile in attributes
  const profile = attributes.employee_profile;
  if (profile && typeof profile === "object" && !Array.isArray(profile)) {
    const id = (profile as Record<string, unknown>).id;
    if (typeof id === "string" && id.trim().length > 0) return id.trim();
  }

  // Fallback: old synced employee_id
  const candidate =
    attributes.employee_id ??
    attributes.employeeId ??
    (identity.employee_id as unknown) ??
    (identity.employeeId as unknown);

  if (typeof candidate === "string" && candidate.trim().length > 0) {
    return candidate.trim();
  }

  if (typeof candidate === "number") {
    return String(candidate);
  }

  return null;
};
